import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconCommunication = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	fill: "none",
	viewBox: "0 0 21 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "silver",
		d: "M17.9 5h-1.663v7.5H5.425v1.667c0 .458.375.833.832.833h9.148l3.327 3.333v-12.5c0-.458-.374-.833-.832-.833zm-3.326 5V2.5c0-.458-.375-.833-.832-.833H2.93c-.457 0-.831.375-.831.833v11.667l3.326-3.334h8.317c.457 0 .832-.375.832-.833z"
	})
});
export default SvgIconCommunication;
